import ASCButton from '@alliancesafetycouncil/asc-button';
import MainCard from '@alliancesafetycouncil/asc-card';
import React from 'react';
import { Col, FormGroup, Label, Row } from 'reactstrap';
import { Field, Form, reduxForm } from 'redux-form';
import SelectInput from '../../../components/FormContainer/SelectInput';
import TextInput from '../../../components/FormContainer/TextInput';
import { required, validEmail, validPhone } from '../../../library/Validation';

let AddGatesForm = ({
  handleNetworkId,
  handleSubmit,
  pristine,
  submitting,
  companies = ['Select Company'],
  sites = [],
  getSites,
  history,
  siteBusy,
  networkBusy,
  getCurriculums,
  curriculums,
}) => {
  return (
    <Form onSubmit={handleSubmit}>
      <MainCard type="main">
        <Row form>
          <Col lg={6}>
            <FormGroup>
              <Field
                type="text"
                name="name"
                id="gateName"
                placeholder=""
                label="Gate Name"
                component={TextInput}
                className="form-control"
                validate={[required]}
              />
            </FormGroup>
          </Col>
        </Row>
        <Row form>
          <Col lg={6}>
            <FormGroup>
              <Field
                id="status"
                name="status"
                className="form-control"
                label="Status"
                validate={[required]}
                component={SelectInput}
              >
                {' '}
                <option>Please Select</option>
                <option value="active">Active</option>
                <option value="inactive">Inactive</option>
              </Field>
            </FormGroup>
          </Col>
        </Row>
        <Row form>
          <Col lg={6}>
            <FormGroup>
              <Field
                id="company"
                name="company"
                label="Company"
                className="form-control"
                component={SelectInput}
                validate={required}
                onChange={(e) => {
                  getSites(e.target.value);
                  getCurriculums(e.target.value);
                  handleNetworkId(e.target.value);
                }}
              >
                <option value={undefined}>Please Select</option>
                {companies
                  .filter((sites) => sites.status === 'active')
                  .sort((a, b) => (a.name > b.name ? 1 : -1))
                  .map((company) => {
                    return (
                      <option key={company.network.id} value={company.network.id}>
                        {company.name}
                      </option>
                    );
                  })}
              </Field>
            </FormGroup>
          </Col>
        </Row>
        <Row form>
          <Col lg={6}>
            <FormGroup>
              <Field
                name="site.id"
                id="site"
                placeholder=""
                label="Site"
                component={SelectInput}
                validate={required}
                className="form-control"
                disabled={siteBusy}
              >
                <option value={''}>{siteBusy ? 'Loading...' : 'Please Select'}</option>
                {sites
                  .filter((sites) => sites.status === 'active')
                  .sort((a, b) => (a.name > b.name ? 1 : -1))
                  .map((site) => {
                    return (
                      <option key={site.id} value={site.id}>
                        {site.name}
                      </option>
                    );
                  })}
              </Field>
            </FormGroup>
          </Col>
        </Row>
        <Row form>
          <Col lg={6}>
            <FormGroup>
              <Field
                type="text"
                name="contact.name"
                id="gateContactName"
                label="Gate Contact (Name)"
                placeholder=""
                component={TextInput}
                validate={required}
                className="form-control"
                required={false}
              />
            </FormGroup>
          </Col>
        </Row>
        <Row form>
          <Col lg={6}>
            <FormGroup>
              <Field
                type="text"
                name="contact.phone"
                id="contactPhone"
                label="Contact Phone"
                placeholder=""
                component={TextInput}
                className="form-control"
                validate={[validPhone]}
                required={false}
              />
            </FormGroup>
          </Col>
        </Row>
        <Row form>
          <Col lg={6}>
            <FormGroup>
              <Field
                type="email"
                name="contact.email"
                component={TextInput}
                label="Contact Email Address"
                id="email"
                placeholder=""
                className="form-control"
                validate={[validEmail]}
                required={false}
              />
            </FormGroup>
          </Col>
        </Row>
        <Row form>
          <Col lg={6}>
            <FormGroup>
              <Field
                id="ilevelCurriculum"
                name="config.entry.iLevel.curriculum"
                label="iLevel Curriculum"
                component={SelectInput}
                className="form-control"
                disabled={networkBusy}
              >
                <option value={'0'}>{networkBusy ? 'Loading...' : 'Same as Site'}</option>
                {curriculums.map((curriculum, i) => {
                  return (
                    <option key={`curriculum-${i}`} value={curriculum.id}>
                      {curriculum.id} - {curriculum.name}
                    </option>
                  );
                })}
              </Field>
            </FormGroup>
          </Col>
        </Row>
        <Row form>
          <Col lg={12}>
            <FormGroup>
              <Label for="exampleText" className="primary-heading">
                Notes
              </Label>
              <Field id="notes" name="notes" component="textarea" className="form-control" />
            </FormGroup>
          </Col>
        </Row>
        <Row form>
          <Col lg={12}>
            <FormGroup>
              <div className="flex flex-row">
                <div className="mr-2">
                  <ASCButton
                    type="save"
                    size="md"
                    onClick={handleSubmit}
                    disabled={pristine || submitting || siteBusy || networkBusy}
                  >
                    Save
                  </ASCButton>
                </div>
                <div>
                  <ASCButton type="tertiary" size="md" onClick={() => history.goBack()}>
                    Cancel
                  </ASCButton>
                </div>
              </div>
            </FormGroup>
          </Col>
        </Row>
      </MainCard>
    </Form>
  );
};

AddGatesForm = reduxForm({
  form: 'addGate',
})(AddGatesForm);

export default AddGatesForm;
